export default (id) => `id_${id}`;
